import type { AskRedoUIMessage } from "../types";

/**
 * Flips a tool part parked on an earlier assistant message to
 * `output-error`, so a stale Approve/Deny card stops rendering.
 */
export function cancelStaleToolPart(
  messages: AskRedoUIMessage[],
  toolCallId: string,
  errorText: string,
): AskRedoUIMessage[] {
  return messages.map((message) => {
    if (message.role !== "assistant") {
      return message;
    }
    let changed = false;
    const parts = message.parts.map((part) => {
      if (
        part.type !== "dynamic-tool" ||
        part.toolCallId !== toolCallId ||
        part.state === "output-available" ||
        part.state === "output-error" ||
        part.state === "output-denied"
      ) {
        return part;
      }
      changed = true;
      return {
        type: "dynamic-tool" as const,
        toolName: part.toolName,
        toolCallId: part.toolCallId,
        state: "output-error" as const,
        input: part.input,
        errorText,
      };
    });
    return changed ? { ...message, parts } : message;
  });
}
